import { Typography } from 'src/ui/common/atoms/typography';
import { Table } from 'src/ui/common/molecules/table';
import styled from 'styled-components';

export const StyledName = styled(Typography)`
  display: block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 16px;
  
  & + * {
    margin-left: 16px;
  }
`;

export const StyledRow = styled(Table.Row)`
  white-space: nowrap;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > *:not(:first-child) {
    margin-top: 0;
    margin-left: 8px;
  }
`;
